import { Game, GameV2 } from '../api/games';
import { filter, pipe, slice, sort } from 'ramda';

const GAME_ITEM_LABELS = ['new', 'top', 'trending'];
const COLLECTION_POSITION = 1;

export const mapGameV2ToGame = (games: GameV2.Game[]): Game[] => {
  const mappedGames = games.map((game) => {
    const collections = game.categories.reduce((acc, item) => {
      const label = GAME_ITEM_LABELS.find(
        (gameItemLabel) => gameItemLabel === item
      );
      if (label) return { acc, [label]: COLLECTION_POSITION };
      return acc;
    }, {});

    return {
      ...game,
      collections,
      real: game.currencies,
      id: game.identifier,
      fullPath: `${game.provider}/${game.seoTitle}`,
      seoPath: game.seoTitle,
      listCollections: game.categories,
    };
  });
  return mappedGames;
};

export function getGamePath(title: string) {
  return title
    .toLowerCase()
    .replace(/\s|&/g, '-')
    .replace(/[^\w\s&-]/g, '')
    .replace(/-{2,}/g, '-')
    .trim();
}

const filterByCategory = ({ categoryId }: { categoryId: string }) => ({
  listCollections,
}: Game) => listCollections.includes(categoryId);

const filterByProvider = ({ providerId }: { providerId?: string }) => ({
  provider,
}: Game) => {
  if (providerId == null) return true;

  return provider === providerId;
};

const sortByCategoryOrder = ({ categoryId }: { categoryId: string }) => (
  aGame: Game,
  bGame: Game
) => aGame.collections[categoryId] - bGame.collections[categoryId];

type GamesFilterParams = {
  categoryId?: string;
  providerId?: string;
  limit?: number;
};

export const gamesFilter = ({
  categoryId = 'all',
  providerId,
  limit = Infinity,
}: GamesFilterParams) =>
  pipe<any, Game[], Game[], Game[], Game[]>(
    filter(filterByCategory({ categoryId })),
    filter(filterByProvider({ providerId })),
    sort(sortByCategoryOrder({ categoryId })),
    slice(0, limit)
  );
